import { render, staticRenderFns } from "./CustomFieldItems.vue?vue&type=template&id=dc14f8f0&scoped=true"
import script from "./CustomFieldItems.vue?vue&type=script&lang=js"
export * from "./CustomFieldItems.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldItems.vue?vue&type=style&index=0&id=dc14f8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc14f8f0",
  null
  
)

export default component.exports